const strings = {
  NAME: 'Namn',
  OUT_OF_ORDER: 'Ur funktion',
  CANCEL: 'Avbryt',
  DONE: 'Klar',
  LAUNDRY_TYPE: 'Tvättyp',
  LAUNDRY_TYPE_INFO:
    'Ställ in om ni har tvättmaskiner eller tvättstugor i huset.',
  LAUNDRY_ROOMS: 'Tvättstugor',
  LAUNDRY_MACHINES: 'Tvättmaskiner',
  LAUNDRY_TYPE_UPDATED: 'Tvättypen har uppdaterats',
  INTERNAL_ERROR: 'Ett oväntat fel har uppstått, var god försök igen.'
}

export default strings



// WEBPACK FOOTER //
// ./src/components/containers/EditLaundryTypeModal/strings.js